import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { propOr } from 'ramda'
import NavigationContent from 'components/navigation/NavigationContent'
import NavigationContentGrouped from 'components/navigation/NavigationContentGrouped'
import { selectCurrentUser } from 'modules/auth/ducks/selectors'
import {
  readNavigationLayout,
  NAV_LAYOUT_GROUPED,
  NAV_LAYOUT_EVENT
} from 'utils/navigationLayout'

const Navigation = () => {
  const currentUser = useSelector(selectCurrentUser)
  const role = propOr('', 'role', currentUser)
  const [layout, setLayout] = useState(readNavigationLayout)

  useEffect(() => {
    const onLayout = () => setLayout(readNavigationLayout())
    window.addEventListener(NAV_LAYOUT_EVENT, onLayout)
    return () => window.removeEventListener(NAV_LAYOUT_EVENT, onLayout)
  }, [])

  const useGrouped =
    layout === NAV_LAYOUT_GROUPED && (role === 'admin' || role === 'worker')

  return (
    <NavigationWrapper>
      {useGrouped ? <NavigationContentGrouped /> : <NavigationContent />}
    </NavigationWrapper>
  )
}

export default Navigation

const NavigationWrapper = styled.div`
  min-width: 300px;
  max-width: 300px;
  height: 100%;
  border-right: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.primary.main};
`
